module.exports = __webpack_public_path__ + "static/media/forward.90cb1fa1.svg";